export default __webpack_public_path__ + "check24.svg";